import Vue from "vue";
import App from "./App.vue";
import router from "@/router/router";
import store from "./store/store";
import echarts from "echarts";
import "./plugins/element.js";
import "./plugins/myPlugin.js";
import "normalize.css";
import "./style/main.scss";
import VueClipBoard from "vue-clipboard2";
import moment from "moment";

Vue.prototype.$moment = moment;
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.use(VueClipBoard);
moment.locale("zh-cn");
new Vue({
  router,
  store,
  echarts,
  render: h => h(App),
}).$mount("#app");


Vue.directive("title",{
  inserted: function(el) {
      document.title = el.getAttribute("title");
      console.log(el);
  },
});